import { IconButton, Scrollbar } from "@carbon6/c6-frontend-design";
import { useState } from "react";
import { McpConnectPanel } from "@/modules/mcp/public";
import { CopyButton } from "@/shared/ui/CopyButton";
import guide from "@/shared/ui/guide.module.css";
import { mcpDraftPrompt, type McpDraftContext } from "../../feature/mcpDraft";
import type { MappingEditor, MappingEditorState } from "../../feature/mappingEditor";
import { MappingRefreshStatus } from "./mapping/MappingRefreshStatus";
import styles from "./McpDraftPane.module.css";

export function McpDraftPane({
  active,
  context,
  editor,
  state,
  onReview,
}: {
  /** 창 최소화 같은 비활성 구간. 연결 패널이 남은 시간을 세지 않는다. */
  active: boolean;
  context: McpDraftContext;
  editor: MappingEditor;
  state: MappingEditorState;
  onReview: () => void;
}) {
  const [checked, setChecked] = useState(false);
  const prompt = mcpDraftPrompt(context);
  return (
    <Scrollbar className={styles.scroll} gutter="auto" aria-label="MCP 연결 확인">
      <div className={guide.text}>
        <h3>MCP 연결 확인</h3>
        <McpConnectPanel active={active} />
        <p>
          연결을 확인한 다음, 아래 지시문으로 초안을 요청해 주세요. 저장 계획을 검토한 뒤
          적용합니다. 적용한 매핑은 이 화면에 자동으로 반영됩니다.
        </p>
        <div className={guide.row}>
          <strong>작업 지시문</strong>
          <CopyButton label="매핑 작업 지시문" value={prompt} />
        </div>
        <details>
          <summary>대상과 지시문 보기</summary>
          <pre>{prompt}</pre>
        </details>
        <IconButton
          text="매핑 불러오기"
          variant="solid"
          disabled={state.refreshing || context.revisionUuid === null}
          onClick={() => {
            setChecked(true);
            void editor.refreshServer();
          }}
        />
        <MappingRefreshStatus state={state} />
        {checked && !state.refreshing && state.refreshError === null ? (
          <p role="status">
            {state.saved.status === "none"
              ? "저장된 매핑이 없습니다. MCP 클라이언트에서 저장 계획을 적용한 뒤 다시 불러와 주세요."
              : state.saved.status === "saved"
                ? "최신 저장본을 보고 있습니다."
                : "서버 상태를 확인해 주세요."}
          </p>
        ) : null}
        <IconButton text="사람 검토로 이동" variant="surface" onClick={onReview} />
      </div>
    </Scrollbar>
  );
}
